module.exports = __webpack_public_path__ + "img/Feature.42bfa7df.png";